// extracted by mini-css-extract-plugin
module.exports = {"HealthPanel":"HealthPanel_HealthPanel__20Z_S","header":"HealthPanel_header__2Z15r","subHeader":"HealthPanel_subHeader__gftEf"};